export default __webpack_public_path__ + "static/media/alertWarning.79e98c53.svg";